import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import {HarbourDuesService} from "./services/harbour-dues.service";

@Component({
  selector: 'app-harbour-dues',
  templateUrl: './harbour-dues.component.html',
  styleUrls: ['./harbour-dues.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HarbourDuesComponent {

  constructor(
    protected harbourDuesService: HarbourDuesService) {
  }

  get port() {
    return this.harbourDuesService.getPort();
  }
}
